<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import IconWithTooltip from "./IconWithTooltip.svelte";

  export let item: any;
  export let options: { [key: string]: string | any }[];
  export let openMenu: boolean;
  export let openDirection: string = null;
  export let icon: { [key: string]: string };
  export let extraClasses: string = "";
  export let menuStyles: string = "";
  export let menuContainer: string = "menu-container";
  export let expandedLight: boolean = false;
  export let tooltip: string = "";
  // TODO: once all uses of PopoverList don't override this, remove it, along with all of the .menu-left-icon custom CSS
  export let useButtonElement: boolean = true;

  const expandedMenuStyle = expandedLight ? " expanded-light" : " expanded";
  const toggleMenu = () => {
    openMenu = !openMenu;
  };

  const clickOutside = (node: Element) => {
    const handleClick = function ({ target }) {
      if (!node.contains(target)) {
        window["closeTimer"] = setTimeout(function () {
          if (openMenu) {
            openMenu = false;
          }
        }, 10);
      } else {
        setTimeout(function () {
          if (window["closeTimer"]) {
            clearTimeout(window["closeTimer"]);
          }
        }, 10);
      }
    };

    const handleClickTimer = setTimeout(function () {
      window.addEventListener("click", handleClick);
    }, 200);

    return {
      destroy() {
        clearTimeout(handleClickTimer);
        window.removeEventListener("click", handleClick);
      },
    };
  };

  const onClickAction = (action: (item: any) => void, item: any) => {
    action(item);
    openMenu = false;
  };

</script>

<style>
  .menu-icon-left.payments-positioning {
    position: relative;
  }

  .menu-icon-left.payments-methods {
    position: relative;
  }

  .menu-icon-left {
    border: 1px solid transparent;
  }

  .menu-icon-left.expanded {
    background: #002b48;
    border: 1px solid #002b48;
    box-sizing: border-box;
    border-radius: 4px;
  }

  .menu-icon-left.expanded-light {
    background: #008fbe;
    border: 1px solid #008fbe;
    box-sizing: border-box;
    border-radius: 4px;
  }

  .menu-container {
    position: absolute;
    height: 0px;
    width: 0px;
    z-index: 10;
  }

  .menu-container > ul > li {
    min-width: 110px;
  }

  .right {
    position: relative;
    right: calc(100% + 10px);
  }

  .bottom-left {
    right: 100px;
    top: 45px;
  }

  .bottom-left-custom-content {
    right: 110px;
    top: 35px;
  }

  .bottom-left-payments-methods {
    position: relative;
    left: -72px;
  }

  .fizz-icon-button-small.is-active {
    background-color: #008fbe;
    fill: #ffffff;
  }

</style>

<div class="fizz-relative">
  {#if useButtonElement}
    <button
      on:click|preventDefault={toggleMenu}
      on:mousedown|preventDefault={() => {}}
      class="fizz-icon-button-small {extraClasses ? extraClasses : ''}"
      class:is-active={openMenu}
      data-testid="popover-list"
    >
      {#if tooltip}
        <IconWithTooltip {tooltip} {icon} showTip={!openMenu} />
      {:else if icon.class}
        <Icon className={icon.class} type={icon.type} />
      {:else}
        <Icon width={icon.width} height={icon.height} type={icon.type} />
      {/if}
    </button>
  {:else}
    <div
      on:click={() => toggleMenu()}
      class="fizz-icon-button-small menu-icon-left{openMenu ? expandedMenuStyle : ''} {extraClasses
        ? extraClasses
        : ''}"
      data-testid="popover-list"
    >
      {#if tooltip}
        <IconWithTooltip {tooltip} {icon} showTip={!openMenu} />
      {:else if icon.class}
        <Icon className={icon.class} type={icon.type} />
      {:else}
        <Icon width={icon.width} height={icon.height} type={icon.type} />
      {/if}
    </div>
  {/if}

  {#if openMenu}
    <div class="{menuContainer} {openDirection}" style={menuStyles ? menuStyles : ""}>
      <ul class="fizz-popover" use:clickOutside>
        {#each options as option}
          {#if !option.hide}
            <li>
              <!-- svelte-ignore a11y-invalid-attribute -->
              <a
                class="popover-list-item {option.cssClass}"
                data-testid="popover-list-item-{option.dataTestIdSuffix}"
                href="#"
                on:click|preventDefault={() => onClickAction(option.action, item)}>{option.name}</a
              >
            </li>
          {/if}
        {/each}
      </ul>
    </div>
  {/if}
</div>
